import apolloClient from '../apolloClient';
import { APPROVE_CUSTOMER_ART_PROOF, REJECT_CUSTOMER_ART_PROOF } from './mutations/artProofReview';

/**
 * Approve an art proof file for customer portal
 * @param {number} campaignArtFileId - The ID of the campaign art file
 * @returns {Promise<Object>} The updated art file
 */
export const approveCustomerArtProofGraphQL = async (campaignArtFileId) => {
  const { data } = await apolloClient.mutate({
    mutation: APPROVE_CUSTOMER_ART_PROOF,
    variables: {
      campaignArtFileId: parseInt(campaignArtFileId, 10)
    }
  });

  return data.approveCustomerArtProof;
};

/**
 * Reject an art proof file for customer portal
 * @param {number} campaignArtFileId - The ID of the campaign art file
 * @param {string} reason - The reason for rejection
 * @returns {Promise<Object>} The updated art file
 */
export const rejectCustomerArtProofGraphQL = async (campaignArtFileId, reason) => {
  const { data } = await apolloClient.mutate({
    mutation: REJECT_CUSTOMER_ART_PROOF,
    variables: {
      campaignArtFileId: parseInt(campaignArtFileId, 10),
      reason
    }
  });

  return data.rejectCustomerArtProof;
};

